import { ReducerFunctions } from "../../utils";
import {
    Expenses,
    AddExpense,
    ExpenseDetails,
    ExpenseFields,
    ListExpensePolicies,
    DeleteExpensePolicies,
    EditExpensePolicies,
    CreateExpensePolicies,
    ShowExpensePolicies,
    ExpenseComments,
    DeleteExpense,
    ExpenseFiles
} from "./expenses";

export const expenses_reducer = ReducerFunctions(Expenses, {});
export const delete_expense_reducer = ReducerFunctions(DeleteExpense, {});
export const expense_comments_reducer = ReducerFunctions(ExpenseComments, {});
export const addExpense_reducer = ReducerFunctions(AddExpense, {});
export const expenseDetails_reducer = ReducerFunctions(ExpenseDetails, {});
export const expenseFields_reducer = ReducerFunctions(ExpenseFields, {});
export const expenseFiles_reducer = ReducerFunctions(ExpenseFiles, {});
export const create_expensePolicies_reducer = ReducerFunctions(CreateExpensePolicies, {});
export const edit_expensePolicies_reducer = ReducerFunctions(EditExpensePolicies, {});
export const show_expensePolicies_reducer = ReducerFunctions(ShowExpensePolicies, {});
export const delete_expensePolicies_reducer = ReducerFunctions(DeleteExpensePolicies, {});
export const list_expensePolicies_reducer = ReducerFunctions(ListExpensePolicies, {});

